import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { TerminalProvider } from './lib/store';
import { LimiteDeError } from './components/ui';
import { App } from './App';
import { registerSW } from 'virtual:pwa-register';
import './styles.css';

/**
 * Recoger la versión nueva sin que nadie recargue.
 *
 * La aplicación es una PWA: el navegador sirve lo que tiene cacheado hasta que
 * alguien recarga a mano. En una pantalla colgada en el taller no hay nadie que
 * recargue, así que una versión nueva podía tardar días en llegar; y quien sí
 * recargaba seguía viendo la de antes y pensaba que no se había desplegado.
 *
 * El monitor se recarga solo en cuanto hay versión nueva, porque no tiene a
 * nadie delante y no puede perder nada. El terminal NO: un operario puede estar
 * a media pantalla de consumos, y recargarle debajo le borraría lo tecleado.
 * Allí entra en el siguiente arranque, que es lo normal.
 */
registerSW({
  immediate: true,
  onNeedRefresh() {
    if (location.pathname.startsWith('/monitor')) location.reload();
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <LimiteDeError>
        <TerminalProvider>
          <App />
        </TerminalProvider>
      </LimiteDeError>
    </BrowserRouter>
  </StrictMode>,
);
